import { createHttpEndpoint } from '../../utils'

import type {
  BuyBackQuote,
  BuyBackQuotePricingEstimation,
  BuybackQuotePostDetails,
  GetBuyBackQuotes,
} from './buyback-quotes.types'

/**
 * Get buyback quotes
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/buyback-quotes-api/definition#/quotes/get_quotes_endpoint}
 */
export const getBuybackQuotes = createHttpEndpoint<GetBuyBackQuotes>({
  method: 'GET',
  operationId: 'getBuybackQuotes',
  path: '/buyback-quotes/api/v1/quotes',
})

/**
 * Create/Update buyback quotes
 * 202 code: Void
 * 207 code: Array<BuybackQuotePostDetails>
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/buyback-quotes-api/definition#/quotes/post_quotes_endpoint}
 */
export const postBuybackQuotes =
  createHttpEndpoint<void | Array<BuybackQuotePostDetails>>({
    method: 'POST',
    operationId: 'postBuybackQuotes',
    path: '/buyback-quotes/api/v1/quotes',
  })

/**
 * Get buyback quote
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/buyback-quotes-api/definition#/quotes/get_product_quote_endpoint}
 */
export const getBuybackQuote = createHttpEndpoint<BuyBackQuote>({
  method: 'GET',
  operationId: 'getBuybackQuote',
  path: '/buyback-quotes/api/v1/products/:productId/quote',
})

/**
 * Get pricing estimations for offline and non-existing listings
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/buyback-quotes-api/definition#/quotes/get_pricing_estimations_endpoint}
 */
export const getPricingEstimation = createHttpEndpoint<
  BuyBackQuotePricingEstimation[]
>({
  method: 'GET',
  operationId: 'getPricingEstimation',
  path: '/buyback-quotes/api/v1/products/:productId/markets/:marketCode/pricing-estimations',
})
